import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import axiosInstance from "../../axios/axiosInstance";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { path } from "../../navigation/path";

const Vehicle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const limit = 10;
  const [vehicle, setVehicle] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const qrRef = useRef<HTMLDivElement>(null);
  const [selectedQRData, setSelectedQRData] = useState<any>(null);

  const handleDownloadQR = async (type: any, qrData: any) => {
    setSelectedQRData(qrData);
    setTimeout(async () => {
      if (qrRef.current) {
        const canvas = await html2canvas(qrRef.current);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: [60, 60] });
        pdf.addImage(imgData, "PNG", 5, 5, 50, 50);
        if (type === "print") {
          pdf.autoPrint();
          window.open(pdf.output("bloburl"), "_blank");
        } else {
          pdf.save("qr-code.pdf");
        }
        setSelectedQRData(null);
      }
    }, 100);
  };

  const handleGetVehicle = async () => {
    try {
      const resp: any = await axiosInstance.get(
        `/api/vehicle/all/search?searchQuery=${searchQuery}&page=${page}&limit=${limit}`
      );
      if (resp.status === 200) {
        setVehicle(resp.data.data);
      } else {
        toast.error("Error in getting vehicle");
      }
    } catch (Error: any) {
      toast.error("Error in getting vehicle");
    }
  };

  const totalPages = Math.ceil(vehicle?.total / limit);

  useEffect(() => {
    handleGetVehicle();
    // eslint-disable-next-line
  }, [page, searchQuery]);

  return (
    <div className="p-4 md:px-12">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Vehicles</h1>
      <div className="mb-4 flex flex-col sm:flex-row gap-2 items-center">
        <div className="relative w-full sm:w-80">
          <input
            type="text"
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8"
            placeholder="Search Vehicle..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              className="absolute right-2 top-1/2 -translate-y-1/2 p-0 m-0 h-5 w-5 flex items-center justify-center text-gray-400 hover:text-gray-700 focus:outline-none bg-transparent border-none"
              onClick={() => setSearchQuery("")}
              tabIndex={-1}
              type="button"
              aria-label="Clear search"
              style={{ lineHeight: 0 }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          )}
        </div>
      </div>
      <div className="overflow-x-auto rounded-lg shadow">
        <table className="min-w-full bg-white">
          <thead>
            <tr className="bg-gray-800 text-white">
              <th className="py-3 px-4 text-center">Registration No</th>
              <th className="py-3 px-4 text-center">Owner</th>
              <th className="py-3 px-4 text-center">Phone</th>
              <th className="py-3 px-4 text-center">Details</th>
            </tr>
          </thead>
          <tbody>
            {vehicle?.data?.map((item: any, index: any) => (
              <tr key={index} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4 text-center">{item?.reg_no}</td>
                <td className="py-2 px-4 text-center">
                  <button
                    className="text-blue-600 hover:underline"
                    onClick={() => navigate(`${path.MEMBERS}/${item?.user?.id}`, { state: { from: location } })}
                  >
                    {item?.user?.name}
                  </button>
                </td>
                <td className="py-2 px-4 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <span>{item?.user?.phone}</span>
                    {item?.user?.phone && (
                      <>
                        <a
                          href={`https://wa.me/${item.user.phone.replace(/[^\d]/g, "")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-green-500 hover:text-green-600"
                          title="Send WhatsApp Message"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-1">
                            <path d="M20.52 3.48A11.87 11.87 0 0012 0C5.37 0 0 5.37 0 12a11.9 11.9 0 001.67 6.09L0 24l6.18-1.62A11.87 11.87 0 0012 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52zM12 22a9.93 9.93 0 01-5.09-1.39l-.36-.21-3.67.96.98-3.58-.23-.37A9.93 9.93 0 012 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.2-7.6c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.28.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.25-1.4-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.34.42-.51.14-.17.18-.29.28-.48.09-.19.05-.36-.02-.5-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.62-.47-.16-.01-.36-.01-.56-.01-.19 0-.5.07-.76.34-.26.27-1 1-.97 2.43.03 1.43 1.03 2.81 1.18 3 .15.19 2.03 3.1 5.02 4.22.7.24 1.25.38 1.68.49.71.18 1.36.15 1.87.09.57-.07 1.65-.67 1.89-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z"/>
                          </svg>
                        </a>
                        <a
                          href={`https://wa.me/${item.user.phone.replace(/[^\d]/g, "")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ml-1 px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-semibold hover:bg-green-200"
                        >
                          Send Message
                        </a>
                      </>
                    )}
                  </div>
                </td>
                <td className="py-2 px-4 text-center flex flex-col items-center gap-2">
                  <button
                    className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs font-semibold hover:bg-blue-200"
                    onClick={() => handleDownloadQR("download", {
                      reg_no: item?.reg_no,
                      owner: item?.user?.name,
                      company: item?.user?.company?.name,
                    })}
                  >
                    Download QR
                  </button>
                  <button
                    className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-semibold hover:bg-green-200"
                    onClick={() => handleDownloadQR("print", {
                      reg_no: item?.reg_no,
                      owner: item?.user?.name,
                      company: item?.user?.company?.name,
                    })}
                  >
                    Print QR
                  </button>
                  {selectedQRData && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                        <div ref={qrRef} className="mb-4">
                          <QRCode size={120} value={JSON.stringify(selectedQRData)} />
                        </div>
                        <button
                          className="mt-2 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                          onClick={() => setSelectedQRData(null)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {(!vehicle?.data || vehicle?.data?.length === 0) && (
              <tr>
                <td colSpan={4} className="py-8 text-center text-gray-400">No vehicles found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center mt-6">
          <nav className="inline-flex rounded-md shadow-sm" aria-label="Pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => setPage(i + 1)}
                className={`px-4 py-2 border text-sm font-medium ${page === i + 1 ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'} ${i === 0 ? 'rounded-l-md' : ''} ${i === totalPages - 1 ? 'rounded-r-md' : ''}`}
              >
                {i + 1}
              </button>
            ))}
          </nav>
        </div>
      )}
    </div>
  );
};

export default Vehicle;
